export default "__VITE_ASSET__CS$vjK9y__"